module.exports = __webpack_public_path__ + "media/images/challenges/talent-league-iv/bullet-5b8b25527fc6a4a43c47e5097b844d3a.svg";